








































import Vue from 'vue';
import { mapActions } from 'vuex';
import { without } from 'lodash';
import { BFormCheckbox, BFormCheckboxGroup } from 'bootstrap-vue';

import LoadingSpinner from '@reciprocity/loading-spinner';

import FileUploadDropzone from '@reciprocity/file-dropzone';
import { verifyImageHeader, fileToBase64 } from '@/utils';
import { components, methods, props } from './common';

enum SelectionMode {
  Upload,
  Input,
}

export default Vue.extend({
  name: 'Logo',
  components: {
    ...components,
    BFormCheckbox,
    BFormCheckboxGroup,
    FileUploadDropzone,
    LoadingSpinner,
  },
  props: {
    ...props,
    logoUploadUrl: {
      type: String,
      required: true,
    },
    uploadEnabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    const selectionMode = this.uploadEnabled && !this.value.external ? SelectionMode.Upload : SelectionMode.Input;

    return {
      uploading: <boolean>false,
      selectionMode,
      SelectionMode, // Including enum in data so it can be used in template
    };
  },
  computed: {
    logoPosition(): string[] {
      return this.value.position === 'hidden' ? [] : [this.value.position];
    },
    logoLabels(): { main: string; link: string } {
      const upload = this.selectionMode === SelectionMode.Upload;
      return {
        main: upload ? 'Image upload*' : 'Logo URL*',
        link: upload ? 'Enter URL manually' : 'Upload image',
      };
    },
  },
  methods: {
    ...mapActions({
      showAlert: 'alerts/show',
      request: 'request',
    }),
    ...methods,
    toggleSelectionMode() {
      this.selectionMode = this.selectionMode === SelectionMode.Upload ? SelectionMode.Input : SelectionMode.Upload;
    },
    async selectFile(file: File) {
      try {
        await verifyImageHeader(file);
        this.uploadImage(file);
      } catch (error) {
        this.showAlert({
          type: 'error',
          message: 'Logo upload failed: invalid file format.',
        });
      }
    },
    async uploadImage(image: File) {
      this.uploading = true;
      try {
        const base64File = await fileToBase64(image);

        const response = await this.request({
          method: 'put',
          url: this.logoUploadUrl,
          data: { imageData: base64File, imageName: image.name },
          defaultErrorHandler: false,
        });
        this.update({ internal: response, external: '' });
      } catch (error) {
        this.showAlert({
          type: 'error',
          message: (error.response.data && error.response.data.message) || 'Something went wrong.',
        });
      } finally {
        this.uploading = false;
      }
    },
    updateExternalUrl(newUrl: string) {
      this.update({ external: newUrl, internal: '' });
    },
    updateLogoPosition(newSelection: string[]) {
      let newPosition = 'hidden';
      if (newSelection.length === 2) {
        newPosition = without(newSelection, this.value.position)[0];
      } else if (newSelection.length === 1) {
        newPosition = newSelection[0];
      }
      this.update({ position: newPosition });
    },
  },
});
